import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { ServiceDetails } from './Services';

const features = [
  [FiIcons.FiClock, 'Reliable Service', 'We show up ready to get the job done properly.'],
  [FiIcons.FiAward, 'Skilled Professionals', 'Our services are handled with care, experience and attention to detail.'],
  [FiIcons.FiCalendar, 'Simple Booking', "Tell us what you need and we'll take care of the rest."],
  [FiIcons.FiHome, 'One Team for Your Home', "From electrical and plumbing to painting and general repairs, we've got you covered."]
];

export default function WhyChoose() {
  return (
    <section className="section why-section" id="about">
      <div className="container">
        <div className="why-layout">
          <div className="why-copy">
            <span className="eyebrow">Dependable by design</span>
            <h2>Why Choose OtterWorks?</h2>
            <p>We make home maintenance simple, reliable and stress-free.</p>
            <div className="feature-list">
              {features.map(([icon, title, text]) => (
                <div className="feature-row" key={title}>
                  <span><SafeIcon icon={icon} /></span>
                  <div><h4>{title}</h4><p>{text}</p></div>
                </div>
              ))}
            </div>
          </div>
          <ServiceDetails />
        </div>
      </div>
    </section>
  );
}